module.exports = __webpack_public_path__ + "assets/img/stihl_allinclusive_sticker_se.356d4689.png";